import { Injectable } from '@angular/core';
import { SessionService } from '@edl-development/edl-common';
import { LocalStorageKeys } from 'src/app/model/enum/local-storage-keys.enum';
import { ObservationTypeValues } from 'src/app/model/enum/observation-type-values.enum';
import { PAETEPRoleType } from 'src/app/model/enum/paetep-role-types.enum';
import { PermissionTypes } from 'src/app/model/enum/permission-types.enum';
import { UserSummaryPermissions } from 'src/app/model/observation/user-summary-permisions.model';
import { BuildingToRolePermission } from 'src/app/model/permissions/building-to-role-permission-dto.model';

@Injectable()
export class PermissionsHelperService {

    constructor(private sessionService: SessionService) { }

    doIHaveAllPermissions = (permissions: PermissionTypes[]) => {
        const myPermissions = this.getMyPermissions();
        return permissions.every(permission => myPermissions[permission]);
    }

    doIHaveAnyPermissions = (permissions: PermissionTypes[]) => {
        const myPermissions = this.getMyPermissions();
        return permissions.length == 0 || permissions.some(permission => myPermissions[permission]);
    }

    canIManageRole = (roleType: PAETEPRoleType) => {
        const rolesICanManage = this.getRolesICanManage();

        return this.canIManageRole_Internal(rolesICanManage, roleType);
    }

    canIManageRoleForBuilding = (buildingId: number, roleType: PAETEPRoleType) => {
        const rolesICanManagePerBuilding = this.getRolesICanManagePerBuilding();

        return this.canIManageRole_Internal(rolesICanManagePerBuilding[buildingId] ?? [], roleType);
    }

    private canIManageRole_Internal = (rolesICanManage: PAETEPRoleType[], roleType: PAETEPRoleType) => {
        return rolesICanManage.findIndex(r => r === roleType) !== -1;
    }

    canCreateObservation = (observationTypeValues: ObservationTypeValues[] = [], userSummaryPermissions?: UserSummaryPermissions) => {
        return (userSummaryPermissions?.canCreateObservation ?? []).reduce((canCreate: boolean, currentValue) => {
            return canCreate || observationTypeValues.includes(currentValue);
        }, false)
    }

    private getMyPermissions = () => {
        return <{ [key: string]: boolean }>(this.sessionService.GetSessionValue(LocalStorageKeys.PERMISSIONS) ?? {} as { [key: string]: boolean });
    }

    private getRolesICanManage = (): PAETEPRoleType[] => {
        return <PAETEPRoleType[] >(this.sessionService.GetSessionValue(LocalStorageKeys.ROLES_I_CAN_MANAGE) ?? {});
    }

    private getRolesICanManagePerBuilding = (): BuildingToRolePermission => {
        return <BuildingToRolePermission>(this.sessionService.GetSessionValue(LocalStorageKeys.ROLES_I_CAN_MANAGE_PER_BUILDING) ?? {});

    }
}